import React, { Fragment, useState, useEffect } from "react";
import PageTitle from "../../layouts/PageTitle";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import { GET, POST} from "../../../services/AxiosService";
import Form from "react-bootstrap/Form";

const FormDonasi = () => {
  const location = useLocation();
    const { id, flag } = useParams();
  const navigate = useNavigate();
  const [locations, setLocations] = useState(location?.state?.from?.length > 0 ? location?.state?.from : "Detail");
  const [data, setData] = useState([]);
  const [buku, setBuku] = useState([]);
  const [formData, setFormData] = useState({
    donaturName: "",
    attachmentLink: "",
    referenceNo: 0,
    type_donation: "",
    paid_at: "",
    paymentMethod: "",
    status_name: "",
    // new
    cara_pembayaran: "",
    paket_buku: "",
    jumlah_paket_buku: "",
    total_donasi: 0,
  });
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
    fetchPaymentMethods();
    fetchDataBuku(); // call it here
  }, [id]);

  const fetchData = async (id) => {
    const res = await GET(`donation/get-web-donation${id}`);
    const detail = res?.data?.detail_donation;
    setFormData({
      ...res?.data,
      paymentMethod: res?.data.paymentMethod?.name || "",
      status_name: res?.data?.order?.status_name, // Ambil nama jika ada
    });
    setData({
      ...res?.data,
      detail_donation: Array.isArray(detail) ? detail : [detail],
    });
    // setData(res?.data.detail_donation || []); // Update data state dengan detail_donation
  };

 const [paymentMethods, setPaymentMethods] = useState([]);




  function currencyFormat(num) {
    num = parseFloat(num);
    return num
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      .replace(/\.00$/, "");
  }

  const getStatus = (status) => {
    if (status === 0) {
      return "Menunggu Pembayaran";
    } else if (status === 1) {
      return "Sudah Dibayar";
    } else if (status === -1) {
      return "Kedaluwarsa";
    } else {
      return status;
    }
  };

  const columns = [
    {
      name: "Tipe Donasi",
      selector: (row) => row.donation_type,
    },
    {
      name: "Detail Donasi",
      selector: (row) => row.book_name,
    },
    {
      name: "Harga (Rp)",
      selector: (row) => row.price, // Safely access price
      cell: (row) => (
        <div style={{ width: "50%", textAlign: "right", display: "block" }}>
          <span>{currencyFormat(row.price ?? 0)}</span>
        </div>
      ),
    },
    {
      name: "Qty",
      selector: (row) => row.book_qty,
      center: true,
    },
    {
      name: "Total (Rp)",
      selector: (row) => row.amount,
      cell: (row) => (
        <div style={{ width: "60%", textAlign: "right", display: "block"  }}>
          <span>{currencyFormat(row.amount)}</span>
        </div>
      ),
    },
  ];

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#FCFCFD",
        fontSize: "14px",
        fontWeight: "bold",
        color: "black",
      },
    },
    rows: {
      style: {
        backgroundColor: "#FFFFFF",
        "&:nth-child(2n)": {
          backgroundColor: "#F3F0FD",
        },
      },
    },
    table: {
      style: {
        marginBottom: "0",
      },
    },
  };


  const fetchPaymentMethods = async () => {
    try {
      const res = await GET("/payment-method");
      if (res && Array.isArray(res.data)) {
        setPaymentMethods(res.data); // <-- Important: set the array inside 'data'
      } else {
        console.error("Invalid response for payment methods:", res);
        setPaymentMethods([]);
      }
    } catch (error) {
      console.error("Failed to fetch payment methods:", error);
      setPaymentMethods([]);
    }
  };

  const fetchDataBuku = async () => {
    const res = await GET(`book-package`);
    setBuku(res?.data);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const newFormData = {
      ...formData,
      [name]: value,
    };
    const total_donasi = hitungTotalDonasi(newFormData.paket_buku, newFormData.jumlah_paket_buku);

    setFormData({
      ...newFormData,
      total_donasi,
    });

    // setFormData((prevData) => ({
    //   ...prevData,
    //   [name]: value,
    // }));

    // setTouched(true);

    const form = e.currentTarget.form;
    const isValid = form.checkValidity();

    setValidated(isValid);

    if (isValid) {
      form.classList.remove("was-validated");
    } else {
      form.classList.add("was-validated");
    }
  };

  // const dataPaketBuku = [
  //   { id: 1, nama: "Paket A", harga: 150000 },
  //   { id: 2, nama: "Paket B", harga: 200000 },
  //   { id: 3, nama: "Paket C", harga: 175000 },
  // ];

const hitungTotalDonasi = (paketId, jumlah) => {
  const selectedPaket = buku.find((paket) => paket.id.toString() === paketId);
  if (!selectedPaket || !jumlah) return "0";

  const total = selectedPaket.price * parseInt(jumlah);
  return total;
};


 const handleSubmit = async (e) => {
  e.preventDefault();

  const requestBody = {
    donatur_name: formData.user_name,
    payment_method_id: formData.cara_pembayaran,
    amount_infaq: Number(formData.total_donasi),
    attachment_link: formData.attachmentLink,
    reference_no: Number(formData.referenceNo),
  };

  if (formData.type_donation === "2") {
    requestBody.bookPackage = [
      {
        bookPackageId: formData.paket_buku,
        book_qty: formData.jumlah_paket_buku,
      },
    ];
  }

  Swal.fire({
    title: "Loading...",
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading(),
  });

  const res = await POST(`/donation/post-web-donation`, requestBody);
  if (res) {
    Swal.fire({
      icon: "success",
      title: "Berhasil membuat donasi baru!",
    }).then(() => {
      Swal.close();
      setFormData({
        user_name: "",
        student_type_name: "",
        type_donation: "",
        cara_pembayaran: "",
        total_donasi: 0,
        paket_buku: "",
        jumlah_paket_buku: 0,
        referenceNo: "",
        attachmentLink: "",
      });
      navigate(`/daftar-donasi`);
    });
  }
};


  return (
    <Fragment>
      <PageTitle activeMenu={`${locations} Daftar Donasi`} motherMenu="Daftar Donasi" />
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header d-flex">
              <h4 className="card-title mb-2">{locations} Donasi</h4>

              <Link className="btn btn-primary" to={`/daftar-donasi`}>
                Kembali
              </Link>
            </div>
            <div className="card-body">
              <div className="form-validation">
                {/* TAMBAH */}
                {flag === "Tambah" ? (
                  <form className="form-valide" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="d-flex flex-wrap">
                        <div className="form-group col-md-6 col-12">
                          <label>Nama Donatur</label>
                            <input
                              className="form-control"
                              type="text"
                              value={formData.user_name}
                              onChange={(e) => setFormData({ ...formData, user_name: e.target.value })}
                              required
                            />                          
                            <Form.Control.Feedback type="invalid">Nama donatur harus diisi.</Form.Control.Feedback>
                        </div>

                        {/* <div className="form-group col-md-6 col-12">
                          <label>Tipe Donatur</label>
                          <input className="form-control" type="text" value={formData.student_type_name} required />
                          <Form.Control.Feedback type="invalid">Tipe donatur harus diisi.</Form.Control.Feedback>
                        </div> */}
                        <div className="form-group col-md-6 col-12">
                          <label>Tipe Donasi</label>
                          <select className="form-control" name="type_donation" value={formData.type_donation} onChange={handleChange} required>
                            <option value="">Pilih tipe donasi</option>
                            {/* <option value="1">Infaq</option> */}
                            <option value="2">Donasi Buku</option>
                          </select>
                          <Form.Control.Feedback type="invalid">Tipe donasi harus dipilih.</Form.Control.Feedback>
                        </div>

                        {/* {formData.type_donation == "1" && (
                          <>
                            <div className="form-group col-md-6 col-12">
                              <label>Nominal Infaq</label>
                             <input
                                    className="form-control"
                                    type="number"
                                    value={formData.total_donasi}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        total_donasi: e.target.value === "" ? 0 : Number(e.target.value),
                                      })
                                    }
                                    required
                                  />
                              <Form.Control.Feedback type="invalid">Nominal infaq harus diisi.</Form.Control.Feedback>
                            </div>
                           <div className="form-group col-md-6 col-12">
                              <label>Cara Pembayaran</label>
                              <select
                                className="form-control"
                                name="cara_pembayaran"
                                value={formData.cara_pembayaran}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Pilih cara pembayaran</option>
                                {paymentMethods.map((method) => (
                                  <option key={method.id} value={method.id}>
                                    {method.description}
                                  </option>
                                ))}
                              </select>
                              <Form.Control.Feedback type="invalid">
                                Cara pembayaran harus dipilih.
                              </Form.Control.Feedback>
                            </div>

                          </>
                        )} */}
                        {formData.type_donation == "2" && (
                          <>
                         <div className="form-group col-md-6 col-12">
                            <label>Paket Buku</label>
                            <select
                              className="form-control"
                              name="paket_buku"
                              value={formData.paket_buku}
                              onChange={handleChange}
                              required
                            >
                              <option value="">Pilih paket buku</option>
                              {buku.map((paket) => (
                                <option key={paket.id} value={paket.id}>
                                  {paket.name}
                                </option>
                              ))}
                            </select>
                            <Form.Control.Feedback type="invalid">
                              Paket buku harus dipilih.
                            </Form.Control.Feedback>
                          </div>


                            <div className="form-group col-md-6 col-12">
                              <label>Jumlah Paket Buku</label>
                              <input className="form-control" type="number" name="jumlah_paket_buku" onChange={handleChange} value={formData.jumlah_paket_buku} required />
                              <Form.Control.Feedback type="invalid">Jumlah paket buku harus diisi.</Form.Control.Feedback>
                            </div>
                                 <div className="form-group col-md-6 col-12">
                              <label>Cara Pembayaran</label>
                              <select
                                className="form-control"
                                name="cara_pembayaran"
                                value={formData.cara_pembayaran}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Pilih cara pembayaran</option>
                                {paymentMethods.map((method) => (
                                  <option key={method.id} value={method.id}>
                                    {method.description}
                                  </option>
                                ))}
                              </select>
                              <Form.Control.Feedback type="invalid">
                                Cara pembayaran harus dipilih.
                              </Form.Control.Feedback>
                            </div>
                            <div className="form-group col-md-6 col-12">
                              <label>Total Donasi</label>
                              <input className="form-control" value={`Rp ${formData.total_donasi.toLocaleString("id-ID")}` || 0} disabled />
                            </div>
                            <div className="form-group col-md-6 col-12">
                              <label>Nomor Referensi</label>
                              <input
                                  className="form-control"
                                  type="number"
                                  name="referenceNo"
                                  value={formData.referenceNo}
                                  onChange={handleChange}
                                  required
                                />
                              <Form.Control.Feedback type="invalid">Nomor referensi harus diisi.</Form.Control.Feedback>
                            </div>
                            <div className="form-group col-md-6 col-12">
                              <label>Link Lampiran</label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    name="attachmentLink"
                                    value={formData.attachmentLink}
                                    onChange={handleChange}
                                    required
                                  /> 
                              <Form.Control.Feedback type="invalid">Link lampiran harus diisi.</Form.Control.Feedback>
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    <div className="form-group mb-3 d-flex">
                      <div className="col-xl-6">
                        <Link className="btn btn-light w-100" to={`/daftar-pesanan-buku`}>
                          Batal
                        </Link>
                      </div>
                      <div className="col-xl-6">
                        <button type="submit" className="btn btn-primary w-100">
                          Simpan Perubahan
                        </button>
                      </div>
                    </div>
                  </form>
                ) : flag === "Detail" ? (
                  <form className="form-valide">
                    <div className="row">
                      <div className="d-flex flex-wrap">
                        <div className="form-group col-md-6 col-12">
                          <label>ID Donatur</label>
                          <input className="form-control" type="text" value={formData.donation_code} required disabled />
                        </div>
                        <div className="form-group col-md-6 col-12">
                          <label>Nama Donatur</label>
                          <input className="form-control" type="text" value={formData.user_name} required disabled />
                        </div>
                        <div className="form-group col-md-6 col-12">
                          <label>Tipe Donatur</label>
                          <input className="form-control" type="text" value={formData.student_type_name} required disabled />
                        </div>
                        {/* <div className='form-group col-md-6 col-12'>
                          <label>Status Pesanan</label>
                          <input
                            className='form-control'
                            type='text'
                            name="status"
                            value={formData.status_name}
                            required
                            disabled
                          />
                        </div> */}
                        <div className="form-group col-md-6 col-12">
                          <label>Status Donasi1</label>
                          <input className="form-control" type="text" value={formData.referenceNo} required disabled />
                        </div>
                        <div className="form-group col-md-6 col-12">
                          <label>Cara Pembayaran1</label>
                          <input className="form-control" type="text" value={formData.payment_method_description	} required disabled />
                        </div>
                        <div className="form-group col-md-6 col-12">
                        
                        </div>
                        {/* <div className="form-group col-md-6 col-12">
                          <label>Waktu Bayar</label>
                          <input
                            className="form-control"
                            type="text"
                            value={
                              formData.paid_at
                                ? (() => {
                                  const tanggal = new Date(formData.paid_at);
                                  const formatTanggal = tanggal?.toLocaleDateString("id-ID", {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                  });
                                  const formatWaktu = tanggal?.toLocaleTimeString("id-ID", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  });
                                  return `${formatTanggal} ${formatWaktu}`;
                                })()
                                : ""
                            }
                            required
                            disabled
                          />
                        </div> */}

                        <h3 className="mb-4 mt-2">Detail Donasi</h3>

                        {data.detail_donation && data.detail_donation.length > 0 ? <DataTable columns={columns} data={data.detail_donation} customStyles={customStyles} /> : <p>Tidak ada data</p>}

                        <table className="table table-striped">
                          <tbody>
                            <tr style={{ background: "#FFFFFF", color: "black" }}>
                              <th className="col-8" scope="row">
                                Total yang Didonasikan (Rp)
                              </th>
                              <td className="col-2" style={{ width: "80%", textAlign: "center", }}> 
                                {currencyFormat(formData.amount)}
                                </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </form>
                  ) : flag === "Detail-Web" ? (
                  <form className="form-valide">
                    <div className="row">
                      <div className="d-flex flex-wrap">
                        <div className="form-group col-md-6 col-12">
                          <label>Nama Donatur</label>
                          <input className="form-control" type="text" value={formData.user_name} required disabled />
                        </div>
                        {/* <div className="form-group col-md-6 col-12">
                          <label>Status Donasi1</label>
                          <input className="form-control" type="text" value={formData.referenceNo} required disabled />
                        </div> */}
                         <div className="form-group col-md-6 col-12">
                          <label>Paket Buku</label>
                          <input className="form-control" type="text" value={formData.book_name	} required disabled />
                        </div>
                         <div className="form-group col-md-6 col-12">
                          <label>Jumlah Paket Buku</label>
                          <input className="form-control" type="text" value={formData.book_qty	} required disabled />
                        </div>
                        <div className="form-group col-md-6 col-12">
                          <label>Cara Pembayaran</label>
                          <input className="form-control" type="text" value={formData.payment_method_description	} required disabled />
                        </div>
                       <div className="form-group col-md-6 col-12">
                      <label>Link Lampiran</label>
                      <input
                        className="form-control"
                        type="text"
                        value={formData.attachment_link}
                        disabled
                      />
                    </div>      
                        {/* <div className="form-group col-md-6 col-12">
                          <label>Waktu Bayar</label>
                          <input
                            className="form-control"
                            type="text"
                            value={
                              formData.paid_at
                                ? (() => {
                                  const tanggal = new Date(formData.paid_at);
                                  const formatTanggal = tanggal?.toLocaleDateString("id-ID", {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                  });
                                  const formatWaktu = tanggal?.toLocaleTimeString("id-ID", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  });
                                  return `${formatTanggal} ${formatWaktu}`;
                                })()
                                : ""
                            }
                            required
                            disabled
                          />
                        </div> */}

                        <h3 className="mb-4 mt-2">Detail Donasi</h3>

                        {data.detail_donation && data.detail_donation.length > 0 ? <DataTable columns={columns} data={data.detail_donation} customStyles={customStyles} /> : <p>Tidak ada data</p>}

                        <table className="table table-striped">
                          <tbody>
                            <tr style={{ background: "#FFFFFF", color: "black" }}>
                              <th className="col-8" scope="row">
                                Total yang Didonasikan (Rp)
                              </th>
                              <td className="col-2">{currencyFormat(formData.amount)}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </form>
                ) : ""}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default FormDonasi;
